// Remembers checkout intent and finalization status:
// 1. In-progress checkout: When a user starts checkout or signs up on a checkout page,
//    they shouldn't be defaulted to /join-church if they exit or refresh.
// 2. Post-checkout finalization: Remembers a paid Stripe checkout waiting for webhook.

const ACTIVE_CHECKOUT_KEY = 'exbabel:activeCheckout';
const PENDING_FINALIZATION_KEY = 'exbabel:pendingCheckout';
const ACTIVE_CHECKOUT_TTL_MS = 2 * 60 * 60 * 1000; // 2 hours
const FINALIZATION_TTL_MS = 30 * 60 * 1000; // 30 minutes

// --- In-Progress Checkout Intent (pre-payment / signup) ---

export function saveActiveCheckout(url) {
    try {
        if (!url || typeof url !== 'string') return;
        // Only save checkout paths
        if (!url.includes('/checkout') && !url.includes('/create-church') && !url.includes('/custom-deal')) {
            return;
        }
        sessionStorage.setItem(ACTIVE_CHECKOUT_KEY, JSON.stringify({ url, savedAt: Date.now() }));
    } catch {
        // Storage can be unavailable
    }
}

export function clearActiveCheckout() {
    try {
        sessionStorage.removeItem(ACTIVE_CHECKOUT_KEY);
    } catch {
        // Storage can be unavailable
    }
}

export function getActiveCheckoutUrl() {
    try {
        const raw = sessionStorage.getItem(ACTIVE_CHECKOUT_KEY);
        if (!raw) return null;
        const { url, savedAt } = JSON.parse(raw);
        if (!url || Date.now() - savedAt > ACTIVE_CHECKOUT_TTL_MS) {
            sessionStorage.removeItem(ACTIVE_CHECKOUT_KEY);
            return null;
        }
        return url;
    } catch {
        return null;
    }
}

// --- Post-Checkout Finalization (Stripe success polling) ---

export function savePendingCheckout(search) {
    try {
        sessionStorage.setItem(PENDING_FINALIZATION_KEY, JSON.stringify({ search, savedAt: Date.now() }));
    } catch {
        // Storage can be unavailable
    }
}

export function clearPendingCheckout() {
    try {
        sessionStorage.removeItem(PENDING_FINALIZATION_KEY);
    } catch {
        // Storage can be unavailable
    }
}

export function getPendingCheckoutUrl() {
    try {
        const raw = sessionStorage.getItem(PENDING_FINALIZATION_KEY);
        if (!raw) return null;
        const { search, savedAt } = JSON.parse(raw);
        if (!search || Date.now() - savedAt > FINALIZATION_TTL_MS) {
            sessionStorage.removeItem(PENDING_FINALIZATION_KEY);
            return null;
        }
        return `/billing?${search}`;
    } catch {
        return null;
    }
}

// Automatically clear checkout intent on user sign-out to prevent cross-account pollution
if (typeof window !== 'undefined') {
    window.addEventListener('exbabel:signout', () => {
        clearActiveCheckout();
        clearPendingCheckout();
    });
}
